// extracted by mini-css-extract-plugin
module.exports = {"removal_pending":"TransactionFailed_removal_pending__2RpV6","animation_container":"TransactionFailed_animation_container__FntQT"};